'use client';

import React, {FC} from 'react';
import {HubspotProvider} from '@aaronhayes/react-use-hubspot-form';

import LandingPageLayout from '../../commons/LandingPageLayout';
import {LandingPageContextProvider} from '../../commons/LandingPageLayout/context';
import Clients from '../../commons/landingPageLibrary/Clients';
import Data from '../../commons/landingPageLibrary/Data/index';
import Disclosures from '../../commons/landingPageLibrary/Disclosures';
import Focus from '../../commons/landingPageLibrary/Focus';
import Hero from '../../commons/landingPageLibrary/Hero/index';
import Newsletter from '../../commons/landingPageLibrary/Newsletter';
import Product from '../../commons/landingPageLibrary/Product';
import Questions from '../../commons/landingPageLibrary/Questions';
import Tutorial from '../../commons/landingPageLibrary/Tutorial';
import Webinar from '../../commons/landingPageLibrary/Webinar';

// This className has the name of the page where the sections are inserted to avoid duplicated code.

const PhysicianSideGig: FC = () => {
  return (
    <HubspotProvider>
      <LandingPageContextProvider>
        <LandingPageLayout background="lighter-background" logoUrl={null}>
          <Hero
            titleText="Grow Your Wealth &#10;with a Financial Advisor"
            descriptionText="You deserve an advisor you can trust. Find, hire, and invest with vetted, fiduciary, financial advisors."
            brandIcons={[]}
            heroImage={{
              png: '/static/img/homepage/physician.png',
              webp: '/static/img/homepage/webp/physician.webp',
              width: 700,
              height: 480,
            }}
          />
          <Data />
          <div className="physicianSideGig spacer--mobile-20 spacer--desktop-70" />
          <Tutorial />
          <div className="physicianSideGig spacer--mobile-30 spacer--desktop-70" />
          <Webinar />
          <div className="physicianSideGig spacer--mobile-40 spacer--desktop-70" />
          <Product />
          <div className="physicianSideGig spacer--mobile-30 spacer--desktop-50" />
          <Clients />
          <div className="physicianSideGig spacer--mobile-30 spacer--desktop-50" />
          <Focus />
          <div
            className="physicianSideGig spacer--mobile-40 spacer--desktop-90"
            style={{background: 'rgb(247, 247, 250)'}}
          />
          <Questions />
          <div
            className="physicianSideGig spacer--mobile-50 spacer--desktop-70"
            style={{background: 'rgb(247, 247, 250)'}}
          />
          <Newsletter />
          <Disclosures />
        </LandingPageLayout>
      </LandingPageContextProvider>
    </HubspotProvider>
  );
};

export default PhysicianSideGig;
